const schema = [
        ['name'],
        ['active'],
        ['tenant'],
];

export default schema;
